declare var FileUploadOptions: any;
declare var FileTransfer: any;

import { CommonServices } from '@/services/CommonServices';
import { apiurl } from '@/config';
import * as OM from '@/model';

class _FileServices {

    UploadDesktop(file: File, userIdentifier: string){
        return CommonServices.uploadFileToUrl<string>(apiurl + "Upload/UploadUserImage", {
            file: file,
            userIdentifier
        });
    }

    UploadCordovaImage(fileUri: string, itemIdentifier: string){
        var prom = new Promise<{ response: OM.Attachment }>((resolve, reject) => {
            var win = (r: any) => {
                resolve(r);
            }
            var fail = (error: any) => {
                reject(error);
            }
            var options = new FileUploadOptions();
            let now = new Date();
            options.fileKey = "file";
            options.params = {
                itemIdentifier
            };
            
            var ft = new FileTransfer();
            ft.upload(fileUri, encodeURI(apiurl + "Upload/UploadUserImage"), win, fail, options);
        })
        return prom;  
    }

    UploadCordovaChatImage(fileUri: string){
        var prom = new Promise<{ response: OM.Attachment }>((resolve, reject) => {
            var win = (r: any) => {
                console.log(r);
                resolve(r);
            }
            var fail = (error: any) => {
                console.log(error);
                reject(error);
            }
            var options = new FileUploadOptions();
            let now = new Date();
            options.fileKey = "file";
            
            var ft = new FileTransfer();
            console.log("uploading now");
            ft.upload(fileUri, encodeURI(apiurl + "Upload/UploadImage"), win, fail, options);
        })
        return prom;  
    }
    UploadDesktopChatImage(file: File){
        return CommonServices.uploadFileToUrl<OM.Attachment>(apiurl + "Upload/UploadImage", {
            file: file
        });
    }

}
export let FileServices = new _FileServices();